import { useMap } from "react-map-gl/maplibre"
import { useStore } from "@/store/store"
const MovementEvents = () => {
    const map = useMap()

    const store = useStore()

    map.current?.on('load', () => {
        })

    map.current?.on('moveend', () => {
        const zoom = map.current?.getZoom()
        if (zoom) {
            store.setMapZoom(zoom)
        }

        const bounds = map.current?.getBounds().getCenter().toArray()
        if (bounds) {
            store.setMapBounds(bounds)
        }        
    })

    return (
        <></>
    )
}

export default MovementEvents